// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./App.css";

// Tạo root và render App
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
